
import React, {useState, useEffect} from 'react'
import Loading from '../Commons/Loading/Loading';
import FooterFormulario from '../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import '../Divisiones/DivisionesDetalles.scss'
import DivisionBanner from '../DivisionContainer/DivisionBanner/DivisionBanner';
import { Modal } from 'react-bootstrap'
import ObraThumb from '../Commons/ObraThumb/ObraThumb';


const EnlacesRadaTilly = () => {


    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };
    
    const handleShow = (paramUrl, paramDesc) => {
        
        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)
        
        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(()=> {
        setTimeout(()=>{
            setLoading(false)
        }, 1000)
    })

    if(loading) {return <Loading />}

    return (

        <section className='container-fluid p-0 containerBlock' > 


            <Modal
              show={show}
              size='lg'
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Red Completa de FTTH Rada Tilly, Chubut</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
              </Modal.Body>

              {/* <Modal.Footer>
                <small >{txtDes}</small>
              </Modal.Footer> */}

            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-telecomunicaciones.jpg" 
                    alt="Obras, andamios." 
                    loading='lazy'
                    className='divisionItem__container--img'    
                />

                <div className='divisionItem__container--textos divisionItem__container--textos-obras' >
                    <h3 className='divisionItem__container--header'>OBRAS</h3>
                    <h1 className='divisionItem__container--title'>TELECOMUNICACIONES</h1>
                </div>

            </div>

            <div className='container-fluid obrasItem__detail'>
                <div className='container animated fast fadeIn'>
                    <Link to={'/obras/'}>
                        <small> 
                        <i className="fas fa-angle-double-left" style={{'paddingBottom':'15px', 'paddingRight': '10px'}} ></i> 
                        Volver a Obras
                        </small>
                    </Link>

                    <div className='row'>

                        <div className='col-md-4'>     
                            <img 
                                src="../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-00.jpg" 
                                alt="Red completa de FTTH en Rada Tilly, Chubut, Argentina. de Agua."
                                className='d-block w-100 divisionItem__detail--header'
                                loading='lazy'
                            /> 
                        </div>

                        <div className='col-md-8 divisionItem__detail--block'>
                            <h1 className='divisionItem__detail--title' >Red Completa de FTTH Rada Tilly</h1>
                            
                            <p  className='divisionItem__detail--text pt-2' > 
                            Red de FTTH completa dentro de la ciudad de Rada Tilly, Pcia del Chubut, donde se realizó el tendido de 65 km de FO, 305 Naps, 82 Botellas de empalme.<br />
                            Obra realizada del 21 de octubre al 5 de diciembre de 2019.<br />
                            </p>

                            <div className='row obras__box justify-content-center' style={{ marginTop: '40px'}}>
                                <div className='col-6 col-sm-4 col-md-6 col-lg-4 obras__card'>
                                    <ObraThumb  
                                        ObraNum  = {'65'}
                                        ObraVal  = {'KM'}
                                        ObraItem = {''}
                                        ObraDet  = {'Cable de FO'}
                                    />
                                </div>
                                <div className='col-6 col-sm-4 col-md-6 col-lg-4 obras__card'>
                                    <ObraThumb  
                                        ObraNum  = {'305'}
                                        ObraVal ={''}
                                        ObraItem = {'NAP'}
                                        ObraDet  = {'Para internet de hogar'}
                                    />
                                </div>
                                <div className='col-6 col-sm-4 col-md-6 col-lg-4 obras__card'>
                                    <ObraThumb  
                                        ObraNum  = {'82'}
                                        ObraVal ={''}
                                        ObraItem = {'Cajas'}
                                        ObraDet  = {'Empalme Derivadoras SCPL'}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    
                   

                    <div className='gallery__cont'>

                        <div className='gallery__cont--column25'>
                            <img    onClick={ () => handleShow('../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-01.jpg', 'Obra tanque de 5.000 m3') } src='../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-01.jpg' alt='Red completa de FTTH en Rada Tilly, Chubut, Argentina.' loading='lazy'/>
                           
                        </div>

                        <div className='gallery__cont--column25'>
                           
                            <img    onClick={ () => handleShow('../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-02.jpg', 'Obra tanque de 5.000 m3') } src='../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-02.jpg' alt='Red completa de FTTH en Rada Tilly, Chubut, Argentina.' loading='lazy' /> 
                            
                        </div>

                        <div className='gallery__cont--column25'>
                            <img    onClick={ () => handleShow('../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-03.jpg', 'Obra tanque de 5.000 m3') } src='../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-03.jpg' alt='Red completa de FTTH en Rada Tilly, Chubut, Argentina.' loading='lazy'/>
                           
                          
                        </div>

                        <div className='gallery__cont--column25'>
                            <img    onClick={ () => handleShow('../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-04.jpg', 'Obra tanque de 5.000 m3') } src='../images/obras/telecomunicaciones/enlaces-en-rada-tilly/enlaces-en-rada-tilly-04.jpg' alt='Red completa de FTTH en Rada Tilly, Chubut, Argentina.' loading='lazy' />
                        </div>


                    </div>
                </div>
            </div>
            <div className='otrasObras__container'>

                <h3 className='divisionItem__bajada--tit text-center'>
                   Otras Obras
                </h3>

                <div className='row divisionItem__proyectosDestacados p-0'> 
                    <DivisionBanner 
                        division = {'Coop de Laguna de los Padres'}
                        imgUrl = {'../images/obras/telecomunicaciones/coop-de-laguna-de-los-padres.jpg'}
                        linkUrl = {'/obras/coop-de-laguna-de-los-padres/'}
                    /> 
                    <DivisionBanner 
                        division = {'FO para Largos Vanos'}
                        imgUrl = {'../images/obras/telecomunicaciones/fo-para-largos-vanos.jpg'}
                        linkUrl = {'/obras/fo-para-largos-vanos/'}
                    /> 
                    <DivisionBanner 
                        division = {'Red DWDM Gran Ancho de Banda FO Zero Pico de Agua.'}
                        imgUrl = {'../images/obras/telecomunicaciones/red-dwdm-gran-ancho-de-banda-fo-zero-pico-de-agua.jpg'}
                        linkUrl = {'/obras/red-dwdm-gran-ancho-de-banda-fo-zero-pico-de-agua/'}
                    />
                    <DivisionBanner 
                        division = {'Enlaces Urbanos punto a punto en Corrientes'}
                        imgUrl = {'../images/obras/telecomunicaciones/enlaces-urbanos-punto-a-punto.jpg'}
                        linkUrl = {'/obras/enlaces-urbanos-punto-a-punto/'}
                    /> 
                </div>

            </div>

            <FooterFormulario className='mt-5' />

        </section>
    )
}

export default EnlacesRadaTilly